<template>
    <table v-if='partie' class="white--text text--darken-3 text-center">
        <tr class="spielerZeile">
            <td class="playerName text-left" rowspan="2">
                {{getNachname(partie.heim.spieler.name)}}
                <br><span class="vorname grey--text">{{getVorname(partie.heim.spieler.name)}}</span>
            </td>
            <td class="point">{{partie.heim.input.d1}}</td>
            <td class="point">{{partie.heim.input.d2}}</td>
            <td class="point">{{partie.heim.input.d3}}</td>
            <td class="point">{{partie.heim.input.d4}}</td>
            <td class="pointTotal">{{partie.heim.kegel}}</td>
        </tr>
        <tr v-if="!isCup" class="spielerZeile">
            <td class="point">{{partie.heim.sp1}}</td>
            <td class="point">{{partie.heim.sp2}}</td>
            <td class="point">{{partie.heim.sp3}}</td>
            <td class="point">{{partie.heim.sp4}}</td>
            <td class="pointTotal">{{partie.heim.sp}}</td>
        </tr>
        <tr v-else class="spielerZeile">
            <td class="point">{{partie.heim.inputAr.ar1}}</td>
            <td class="point">{{partie.heim.inputAr.ar2}}</td>
            <td class="point">{{partie.heim.inputAr.ar3}}</td>
            <td class="point">{{partie.heim.inputAr.ar4}}</td>
            <td class="pointTotal">{{partie.heim.ar}}</td>
        </tr>
        <tr><td></td></tr>
        <tr class="spielerZeile">
            <td class="playerName text-left" rowspan="2">
                {{getNachname(partie.gast.spieler.name)}}
                <br><span class="vorname grey--text">{{getVorname(partie.gast.spieler.name)}}</span>
            </td>
            <td class="point">{{partie.gast.input.d1}}</td>
            <td class="point">{{partie.gast.input.d2}}</td>
            <td class="point">{{partie.gast.input.d3}}</td>
            <td class="point">{{partie.gast.input.d4}}</td>
            <td class="pointTotal">{{partie.gast.kegel}}</td>
        </tr>
        <tr v-if="!isCup"  class="spielerZeile">
            <td class="point">{{partie.gast.sp1}}</td>
            <td class="point">{{partie.gast.sp2}}</td>
            <td class="point">{{partie.gast.sp3}}</td>
            <td class="point">{{partie.gast.sp4}}</td>
            <td class="pointTotal">{{partie.gast.sp}}</td>
        </tr>
        <tr v-else class="spielerZeile">
            <td class="point">{{partie.gast.inputAr.ar1}}</td>
            <td class="point">{{partie.gast.inputAr.ar2}}</td>
            <td class="point">{{partie.gast.inputAr.ar3}}</td>
            <td class="point">{{partie.gast.inputAr.ar4}}</td>
            <td class="pointTotal">{{partie.gast.ar}}</td>
        </tr>
    </table>
</template>

<script>
    export default {
        name: "stream-details-bahn",
        props: ['partie', 'isCup'],
        methods: {
            getName(name){ return name.substr(9) },
            getNachname(name){ return this.getName(name).split(' ')[0] },
            getVorname(name) {return this.getName(name).replace(this.getNachname(name), ' ').trim()}
        },
    }
</script>

<style scoped>
    .playerName {font-size: 32px; padding-left: 12px; max-width: 430px; width: 430px;
        background-color: #252525; line-height: 0.9}
    .vorname {font-size: 24px; }
    .point { width: 60px; background-color: #393939 }
    .pointTotal { width: 70px; background-color: #454545; font-weight: 500 }
    .spielerZeile {height: 44px; background-color: black;}
    table { font-size: 24px; border-collapse: collapse; background-color: #333 }
    td { border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black; }
</style>